/**
 * @edited by libaiqi
 * @editDate 2018/10/24
 * @description 应用监控 appDetail
 * @author zhijie.huang
 * @date 2017/4/27
 */

import Logic from '../logic-base'

const GROUP_HOST = 'HOST'
const APP_NAME_HOST = 'hostperf'
const GROUP_COMPONENT = 'COMPONENT'

const appDetailBiz = new Logic()

appDetailBiz.getHostIP = function (appName) {
  return this.ajax({
    ...this.REQUEST_OPT.kpi.getHostIp,
    data: {
      applications: appName
    }
  })
}

appDetailBiz.getAppIPAndPort = function (group, appName) {
  return this.ajax({
    ...this.REQUEST_OPT.nodeManager.getIpList,
    data: {
      group: group,
      appName: appName
    }
  })
}

appDetailBiz.getIPForSelect = function (group, appName) {
  return this.ajax({
    ...this.REQUEST_OPT.nodeManager.getIpList,
    data: {
      group: group,
      appName: appName
    }
  })
}

appDetailBiz.getServerKpiMapData = function (group) {
  return appDetailBiz.getKpiMapData(group, APP_NAME_HOST)
}

appDetailBiz.getHostKpiMapData = function (siteCode) {
  return appDetailBiz.getKpiMapData(GROUP_HOST, APP_NAME_HOST, '', siteCode)
}

appDetailBiz.getComponentKpiMapData = function (appName) {
  return appDetailBiz.getKpiMapData(GROUP_COMPONENT, appName)
}

appDetailBiz.getKpiMapData = function (group, appName, categoryType, siteCode) {
  return this.ajax({
    ...appDetailBiz.REQUEST_OPT.kpi.getKpiMap,
    data: {
      group: group,
      appName: appName,
      categoryType: categoryType,
      siteCode: siteCode
    }
  })
}

export default appDetailBiz
